// Assets
import { ReactComponent as IconHN } from '../../../../assets/icons/Paises/Icono-Honduras.svg';
import { ReactComponent as IconCR } from '../../../../assets/icons/Paises/Icono-CostaRica.svg';
import LogoAsegurame from '../../../../assets/images/Logos/AsegurameLogo.svg';

export const PAISES_ASEGURAME = [
  {
    id: 'HN',
    label: 'Honduras',
    icon: <IconHN className="max-h-[28px] max-w-[28px]" />,
  },
  {
    id: 'CR',
    label: 'Costa Rica',
    icon: <IconCR className="max-h-[28px] max-w-[28px]" />,
  },
];

export const LOGO_HEADER = {
  ASEGURAME: {
    logo: LogoAsegurame,
    className: 'w-40 h-9 md:w-48 md:h-auto',
  },
  CATOLICA: {
    logo: 'https://aseguramecr.s3.us-east-2.amazonaws.com/Imagenes/Logos/logo-hospital-catolica.svg',
    className: 'max-h-10 w-full lg:max-h-14',
  },
};

export const MOSTRAR_MENU_WEB = {
  ASEGURAME: true,
  CATOLICA: false,
};
